import { gql } from "@apollo/client";

export const GET_AD = gql`
  query feed($id: Int!) {
    feed(id: $id) {
      id
      description
      cover
      venueId
      hashtags {
        hashtagId
      }
      media {
        type
        key
        isCover
      }
      ad {
        id
        feedId
        title
        venueId
        endDate
      }
    }
  }
`;
